/**
 * Maps Monarch uiConfig / uiConfigMessage into the nested shape KORE `showChatIcon` expects (parity with fuel-cart).
 */

const coerceStyleValue = (value) => {
  const lower = String(value).trim().toLowerCase();
  if (lower === "true") return true;
  if (lower === "false") return false;
  const num = Number(value);
  if (String(value).trim() !== "" && !Number.isNaN(num)) return num;
  return value;
};

/**
 * Input: [{ name: "color", value: "#fff" }, ...]
 * Output: { color: "#fff", ... }
 */
export const mapStylesArrayToObject = (raw) => {
  if (raw == null || !Array.isArray(raw)) return undefined;
  const result = raw.reduce((acc, item) => {
    if (item?.name != null) {
      acc[item.name] = coerceStyleValue(String(item.value ?? ""));
    }
    return acc;
  }, {});
  return Object.keys(result).length > 0 ? result : undefined;
};

/**
 * Input: [{ type: "chatBubbleStyles", styles: [{ name, value }, ...] }, ...]
 * Output: { chatBubbleStyles: { ... }, ... }
 */
export const mapUiConfigToNested = (raw) => {
  if (raw == null) return undefined;

  if (Array.isArray(raw)) {
    const result = raw.reduce((acc, item) => {
      if (item?.type && Array.isArray(item.styles)) {
        acc[item.type] = mapStylesArrayToObject(item.styles) ?? {};
      }
      return acc;
    }, {});
    return Object.keys(result).length > 0 ? result : undefined;
  }

  if (typeof raw === "object" && !Array.isArray(raw)) {
    return Object.keys(raw).length > 0 ? raw : undefined;
  }

  return undefined;
};

/**
 * Merged `ui_config` object for Kore (base ui + optional messageStyles).
 */
export const buildKoreUiConfigFromChatConfig = (chatConfig) => {
  if (!chatConfig || typeof chatConfig !== "object") return undefined;
  const baseUiConfig = mapUiConfigToNested(chatConfig.uiConfig);
  const messageStyles = mapStylesArrayToObject(chatConfig.uiConfigMessage);
  if (baseUiConfig == null && messageStyles == null) return undefined;
  return {
    ...(baseUiConfig ?? {}),
    ...(messageStyles != null && { messageStyles }),
  };
};
